<template>
  <div class="global-player">
    <div class="global-player-main-player flex1 width-0">
      <AudioPlayer
        ref="refAudioPlayer"
        theme="light"
        v-if="renderData.ifRenderPlayer"
        :switch="true"
        type="globalPlayer"
        :loop="props.loop"
        :renderStyle="{
          '--opLoadingColor': '#fff',
          '--opSize': '48px',
          '--opIcoSize': '24px',
          '--opBgColor': 'transparent',
          '--opMargin': '0 70px',
          '--opSwitchSize': '36px',
          '--opSwitchIcoSize': '24px',
          '--opSwitchBgHover': 'rgba(0,0,0,0.1)',

          '--titleColor': '#fff',
          '--titleFontSize': '14px',
          '--titleFontWeight': '500',

          '--timeColor': '#FFFFFF4D',
          '--timeFontSize': '10px',
          '--timeFontWeight': 'normal',
          '--timeMinWidth': '36px',
          '--barColor': 'rgba(255, 255, 255,  0.3)',
          '--barHeight': '2px',

          '--seekbarMargin': '0',
          '--progressbarColor': '#fff',
          '--progressSliderSize': '8px',
          '--progressSliderColor': '#fff',
          '--progressSliderHoverColor': 'rgba(255, 255, 255, 0.3)',
        }"
        :url="renderData.url"
        :duration="renderData.duration"
        :highPosition="props.highPosition"
        :perContinuousPlaybackTimeCallback="props.perContinuousPlaybackTimeCallback"
        v-model:isGenerating="renderData.isGenerating"
        @switch="doSwitch"
        @syncPlayState="doSyncPlayState"
        @syncProgress="doSyncProgress"
        @syncDuration="doSyncDuration"
        @syncLoadingState="doSyncLoadingState"
        @play="doPlay"
      ></AudioPlayer>
    </div>

    <!-- <div
      class="global-player-circle-mode global-player-ico-btn pointer fn-inline"
      @click="toggleLoop"
    >
      <i
        class="block"
        :class="{
          'repeat-false': !renderData.loop,
          'repeat-true': renderData.loop,
        }"
      ></i>
    </div>
    <div class="slot-playlist fn-inline" v-if="$slots.playlist">
      <slot name="playlist"></slot>
    </div> -->

    <!-- <div class="global-player-volume global-player-ico-btn pointer fn-inline">
      <div class="global-player-volume-slider">
        <el-slider
          v-model="renderData.volumeProgress"
          vertical
          @change="changeVolume"
          tooltip-class="global-player-volume-slider-tooltip"
        >
        </el-slider>
      </div>
      <div class="global-player-volume-toogle-contro">
        <i class="block"></i>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  defineExpose,
  onMounted,
  nextTick,
  getCurrentInstance,
} from "vue";
import AudioPlayer from "./MobileAudioPlayer.vue";


const props = defineProps({
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  highPosition: {
    type: Number,
    default: null,
  },
  loop: {
    type: Boolean,
    default: false,
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
  perContinuousPlaybackTimeCallback: {
    type: Function,
     default: () => {},
  },
});

const emits = defineEmits([
  "log",
  "drawEqualizer",
  "syncDuration",
  "syncPlayState",
  "syncLoadingState",
  "syncProgress",
  "switch",
  "play",
  "curPlayEnded",
  "",
  "update:isGenerating",
]);

const refAudioPlayer = ref(null);

const renderData = reactive({
  url: props.url,
  duration: props.duration,
  ifRenderPlayer: true,
  isPlaying: false,
  tempPlayStatus: false,
  loop: false,
  volumeProgress: 100,
  volume: 0,
  isLoading: false,
  progress: 0,
  isGenerating: false,
});

const curPlayEnded = ({ currentUrl, player }) => {
      if (renderData.url == currentUrl) {
        if (!props.loop) {
          setTimeout(() => {
            emits("switch", "next");
          }, 20);
        }
      }
    }

const init = () => {
  const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))?.appContext;
  if(appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer && !renderData.hasInit){
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setGlobalPersonalizedConfig({
      endedToStart: true, // 播放结束后是否回归零位置
      loop: false, // 是否循环播放
      fadeInTime: 0, // 淡入时间
      fadeOutTime: 0, // 淡出时间
      volumeGain: 0, // 音量偏移，当前歌曲音量降低或增加0-1，音量最大为1
      analyser: false, // 创建频谱直方图
      canSeekNotCurrent: false, // 当不是当前播放时是否可以调整下次播放位置
      autoToStartIfNotCurrent: false, // 当不是当
    });
  
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
      "curPlayEnded",
      curPlayEnded
    );
    renderData.hasInit = true;
  }else{
    renderData.hasInit = false;
  }
  renderData.url = props.url;
  renderData.duration = props.duration;
};

// const onCurPlayEnded = ({ currentUrl, player }) => {
//   if (renderData.url == currentUrl) {
//     emits("curPlayEnded", { currentUrl, player });
//     if (!renderData.loop) {
//       setTimeout(() => {
//         emits("switch", "next");
//       }, 20);
//     }
//   }
// };
const resetUrl = (url) => {
  refAudioPlayer.value?.triggleEmitsPerContinuousPlaybackTimeCallback();
  renderData.ifRenderPlayer = false;
  nextTick(() => {
    renderData.url = url;
    renderData.duration = props.duration;
    renderData.ifRenderPlayer = true;
    // nextTick(() => {
    //   const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))?.appContext;
    //   appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(renderData.url, 0);
    // });
  });
};

const doSyncPlayState = (isPlaying) => {
  renderData.isPlaying = isPlaying;
};

const doSyncLoadingState = (isLoading) => {
  renderData.isLoading = isLoading;
};

const doSyncProgress = (progress, startTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
};

const doSyncDuration = (duration) => {
  renderData.duration = duration;
};

const doPlay = (url) => {
  emits("play", url);
};

// const changeVolume = () => {
//   renderData.volume = renderData.volumeProgress / 100;
//   const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))?.appContext;
//   appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setVolume(renderData.volume);
// };

const doSwitch = (data) => {
  refAudioPlayer.value?.changeOp(false);
  nextTick(() => {}).then(() => {
    emits("switch", data);
  });
};

watch(
  () => renderData.isPlaying,
  () => {
    emits("syncPlayState", renderData.isPlaying);
  }
);
watch(
  () => renderData.isLoading,
  () => {
    emits("syncLoadingState", renderData.isLoading);
  }
);
watch(
  () => renderData.progress,
  () => {
    emits("syncProgress", renderData.progress, renderData.startTime);
  }
);
watch(
  () => renderData.duration,
  () => {
    emits("syncDuration", renderData.duration);
  }
);

watch(
  () => {
    return props.duration;
  },
  (newVal) => {
    renderData.duration = newVal;
  }
);

watch(
  () => props.url,
  (newVal) => {
    if (renderData.url != props.url) {
      resetUrl(newVal);
    }
  }
);
watch(
  () => {
    return props.isGenerating;
  },
  (newValue) => {
    renderData.isGenerating = newValue;
  }
);

watch(
  () => {
    return renderData.isGenerating;
  },
  (newValue) => {
    emits("update:isGenerating", newValue);
  }
);

onMounted(() => {
  renderData.isGenerating = props.isGenerating;
  init();
});
onBeforeUnmount(() => {
  const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))?.appContext;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releaseGlobalListener("curPlayEnded", curPlayEnded);
  refAudioPlayer.value?.triggleEmitsPerContinuousPlaybackTimeCallback();
});
defineExpose({
  changeTempOp: (isPlay) => {
    if (isPlay) {
      if (renderData.tempPlayStatus) {
        refAudioPlayer.value?.changeOp(true);
      }
    } else {
      renderData.tempPlayStatus = renderData.isPlaying;
      refAudioPlayer.value?.changeOp(false);
    }
  },
  changeOp: (isPlay) => {
    refAudioPlayer.value?.changeOp(isPlay);
  },
  init(){
    init();
    refAudioPlayer.value?.init();
  }
});
</script>
<style lang="scss">
.global-player-volume-slider-tooltip {
  pointer-events: none;
}
.global-player {
  display: flex;
  align-items: center;
  .global-player-toggle-op {
    margin-left: 12px;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    background: linear-gradient(146deg, #98ff8e 9%, #3dd5ff 93%);
    margin: 0 14px;
  }
  .global-player-ico-btn {
    height: 40px;
    width: 40px;
    padding: 12px;
    i {
      width: 16px;
      height: 16px;
    }
  }
  .global-player-circle-mode {
    margin-left: 8px;
    i.repeat-true {
      background: url("@/assets/img/repeat-one-ico.png");
      background-size: 100% 100%;
    }
    i.repeat-false {
      background: url("@/assets/img/circle-ico.png");
      background-size: 100% 100%;
    }
  }
  .global-player-playlist {
    i {
      background: url("@/assets/img/playlist-ico.png");
      background-size: 100% 100%;
    }
  }
  .global-player-volume {
    padding: 0;
    position: relative;
    .global-player-volume-toogle-contro {
      padding: 12px;
    }
    i {
      background: url("@/assets/img/volume-ico.png");
      background-size: 100% 100%;
    }
    .global-player-volume-slider {
      position: absolute;
      display: none;
      bottom: 38px;
      left: 0;
      width: 38px;
      height: 150px;
      border-radius: 12px;
      background: #3e3450;
      backdrop-filter: blur(10px);
      padding: 4px 0;

      .el-slider.is-vertical {
        height: 112px;
        margin: 12px 0 0 0;
        .el-slider__runway {
          height: 100% !important;
          border-radius: 4px 4px 4px 4px;
          box-sizing: content-box;
          background-color: transparent;
          width: 2px;
          margin: 0 18px;
        }
        .el-slider__runway::before {
          margin-top: 6px;
          content: "";
          display: block;
          height: 100px;
          width: 100%;
          border-radius: 4px 4px 4px 4px;
          box-sizing: content-box;
          background-color: rgba(255, 255, 255, 0.2);
        }
        .el-slider__button {
          width: 12px;
          height: 12px;
          background: #94adff;
          transition: unset !important;
          vertical-align: unset;
          border: none;
        }
        .el-slider__button-wrapper {
          left: -11px;
          height: 24px;
          width: 24px;
          line-height: 24px;
          z-index: 0;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .el-slider__bar {
          height: 4px;
          width: 2px;
          left: 0;
          border-radius: 4px 4px 4px 4px;
          background: #94adff;
        }
      }
    }
    &:hover {
      .global-player-volume-slider {
        display: block;
      }
    }
  }
}
</style>
